import { TAuthConfig } from 'react-oauth2-code-pkce';

const authScopes = [
	'openid',
	'offline_access',
	'auth.account.write',
	'auth.account.read',
	'api.client.read',
	'api.client.write',
	'api.mobile.read',
	'api.mobile.write',
	'files.client.user_files.read',
	'files.client.user_files.write',
	'files.mobile.user_files.read',
	'files.mobile.user_files.write',
];

const WipeAuthSessionStorage = () => {
	new URLSearchParams(window.location.search).delete('authUrl');
	sessionStorage.removeItem(`PKCE_code_verifier`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_token`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_idToken`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_loginInProgress`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_refreshToken`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_refreshTokenExpire`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_token`);
	sessionStorage.removeItem(`${process.env.REACT_APP_SITE_KEY}_tokenExpire`);
};

const WipeAuthOverride = () => {
	sessionStorage.removeItem(`auth-override-url`);
	WipeAuthSessionStorage();
	window.location.reload();
};

const locationQuery = new URLSearchParams(window.location.search);
const sessionAuthHost = sessionStorage.getItem('auth-override-url');

let authHostOverride: string | undefined | null =
	process.env.REACT_APP_ENV_LABEL !== 'Production' && sessionAuthHost
		? sessionAuthHost
		: process.env.REACT_APP_AUTH_HOST;

if (process.env.REACT_APP_ENV_LABEL !== 'Production' && locationQuery.get('authUrl')) {
	authHostOverride = locationQuery.get('authUrl');
	sessionStorage.setItem('auth-override-url', locationQuery.get('authUrl') as string);
	locationQuery.delete('authUrl');
	WipeAuthSessionStorage();
}

const authConfig: TAuthConfig = {
	clientId: process.env.REACT_APP_AUTH_CLIENT_ID || 'NotSet',
	authorizationEndpoint: `${authHostOverride}/authorize`,
	tokenEndpoint: `${authHostOverride}/token`,
	logoutEndpoint: `${authHostOverride}/endsession`,
	logoutRedirect: `${process.env.REACT_APP_AUTH_LOGOUT_URI}`,
	redirectUri: `${process.env.REACT_APP_AUTH_REDIRECT_URI}`,
	scope: authScopes.toString().replace(/,/g, ' '),
	decodeToken: false,
	clearURL: false,
	storage: 'session',
	storageKeyPrefix: `${process.env.REACT_APP_SITE_KEY}_`,
	extraAuthParameters: navigator.webdriver ? { acr_values: 'usingWebDriver' } : undefined,
	preLogin: () => {
		if (window.location.pathname.indexOf('oauth-callback') === -1) {
			localStorage.setItem(
				'lastPath',
				`${window.location.pathname}${
					window.location.search.indexOf('authUrl') === -1 ? window.location.search : ''
				}`,
			);
		}
	},
	postLogin: () => {
		if (localStorage.getItem('lastPath')) {
			window.location.replace(localStorage.getItem('lastPath') as string);
		}
	},
};

export { authConfig, WipeAuthOverride, WipeAuthSessionStorage };
